function TheNewEuropeanRedirects({ validCountryPaths }) {
  // Initialise variables.
  const homepagePath = sessionStorage.getItem('homepagePath');
  const pathName = window.location.pathname;
  const currentPath = (pathName.length > 1 && pathName.endsWith('/')) ? pathName.slice(0, -1) : pathName;

  // Start redirect.
  function init() {
    if(homepagePath) return redirectHomepage(homepagePath);
    getUserCountry()
      .then(response => {
        const userCountry = response.headers.get('x-pugpig-vary-detected-country') || 'gb';
        const validHomePath = validCountryPaths[userCountry];

        if(!validHomePath) return console.log('Country does not have a valid path set')

        sessionStorage.setItem('homepagePath', validHomePath);
        redirectHomepage(validHomePath);
      }).catch(e => {
        console.log("User country could not be retrieved'");
      })
  }

  // Fetch users country from the pages header.
  const getUserCountry = () => fetch(window.location.href);

  // If the country exists in the passed config, set the homepage to the path.
  function redirectHomepage(homepagePath) {
    const isPathPresent = Object.values(validCountryPaths).find(path => path === currentPath);
    if (!isPathPresent || currentPath === homepagePath) return
    window.location.href = homepagePath;
  }

  // Attach event listeners and set active classes.
  function bindRedirectSwitcher(button) {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const href = e.currentTarget.href
      const countryPath = e.currentTarget.dataset.path;
      if (countryPath && homepagePath && countryPath !== homepagePath) {
        sessionStorage.setItem('homepagePath', countryPath);
        return location.href = countryPath;
      }
      if (!homepagePath) location.href = href;
    })
  }

  function bindEventListeners(switcherButtons) {
    if(!switcherButtons || switcherButtons.length <= 0) return
    switcherButtons.forEach(button => {
      if(button.dataset.path === homepagePath) button.classList.add('active')
      bindRedirectSwitcher(button)
    })
  }

  // Export functions.
  return {
    init,
    bindEventListeners
  }
}


const validCountryPaths = { gb: '/', eu: '/international' }
const newEuropeanRedirects = TheNewEuropeanRedirects({ validCountryPaths })
newEuropeanRedirects.init()

document.addEventListener('DOMContentLoaded', () => {
  const switcherButtons = document.querySelectorAll('.ne-nav__flag-link')
  newEuropeanRedirects.bindEventListeners(switcherButtons)
})